import React from 'react'

function Member() {
  return (
    <>
        <section className='section p-0'>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-12 text-center">
                        <div className="section-title mb-0 pb-2">
                            <h4 className="title mb-4">Манай баг</h4>
                            <p className="text-muted para-desc mx-auto mb-0"></p>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-lg-3 col-md-6 mt-4 pt-2">
                        <div className="card team team-primary text-center border-0">
                            <div className="position-relative">
                                <img src="assets/images/pages/team1.png" className="img-fluid rounded  shadow" alt="" />
                                <ul className="list-unstyled mb-0 team-icon">
                                    <li className="list-inline-item"><a href="#" className="btn btn-primary btn-pills btn-sm btn-icon"><i data-feather="facebook" className="icons"></i></a></li>
                                    <li className="list-inline-item"><a href="#" className="btn btn-primary btn-pills btn-sm btn-icon"><i data-feather="instagram" className="icons"></i></a></li>
                                    <li className="list-inline-item"><a href="#" className="btn btn-primary btn-pills btn-sm btn-icon"><i data-feather="twitter" className="icons"></i></a></li>
                                </ul>
                            </div>
                            <div className="card-body py-3 px-0 content">
                                <h6 className="mb-0"><a href="#" className="name text-dark"><span className='text-primary'>БЯМБАДАГВА</span> Баяраагийн</a></h6>
                                <small className="designation text-muted">Захирал</small><br/>
                                <small className="designation text-bold">Доктор (Ph.D), Монгол Улсын Зөвлөх инженер</small>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-3 col-md-6 mt-4 pt-2">
                        <div className="card team team-primary text-center border-0">
                            <div className="position-relative">
                                <img src="assets/images/pages/team2.jpg" className="img-fluid rounded shadow" alt="" />
                                <ul className="list-unstyled mb-0 team-icon">
                                    <li className="list-inline-item"><a href="#" className="btn btn-primary btn-pills btn-sm btn-icon"><i data-feather="facebook" className="icons"></i></a></li>
                                    <li className="list-inline-item"><a href="#" className="btn btn-primary btn-pills btn-sm btn-icon"><i data-feather="instagram" className="icons"></i></a></li>
                                    <li className="list-inline-item"><a href="#" className="btn btn-primary btn-pills btn-sm btn-icon"><i data-feather="twitter" className="icons"></i></a></li>
                                </ul>
                            </div>
                            <div className="card-body py-3 px-0 content">
                                <h6 className="mb-0"><a href="#" className="name text-dark"><span className='text-primary'>ПҮРЭВТОГТОХ</span> Балдангийн</a></h6>
                                <small className="designation text-muted">Бодлогын зөвлөх</small><br/>
                                <small className="designation text-bold">Шинжлэх ухааны доктор (Sc.D), профессор, Гавьяат багш, Монгол Улсын Зөвлөх инженер</small>
                            </div>
                        </div>
                    </div>
                    
                    <div className="col-lg-3 col-md-6 mt-4 pt-2">
                        <div className="card team team-primary text-center border-0">
                            <div className="position-relative">
                                <img src="assets/images/pages/team3.png" className="img-fluid rounded  shadow" alt="" />
                                <ul className="list-unstyled mb-0 team-icon">
                                    <li className="list-inline-item"><a href="#" className="btn btn-primary btn-pills btn-sm btn-icon"><i data-feather="facebook" className="icons"></i></a></li>
                                    <li className="list-inline-item"><a href="#" className="btn btn-primary btn-pills btn-sm btn-icon"><i data-feather="instagram" className="icons"></i></a></li>
                                    <li className="list-inline-item"><a href="#" className="btn btn-primary btn-pills btn-sm btn-icon"><i data-feather="twitter" className="icons"></i></a></li>
                                </ul>
                            </div>
                            <div className="card-body py-3 px-0 content">
                                <h6 className="mb-0"><a href="#" className="name text-dark"><span className='text-primary'>ОРХОНТУУЛ</span> Борягийн</a></h6>
                                <small className="designation text-muted">Шинжлэх ухаан, технологийн судалгаа хариуцсан дэд захирал</small><br/>
                                <small className="designation text-bold">Доктор (Ph.D), дэд профессор, Монгол Улсын Зөвлөх инженер</small>
                            </div>
                        </div>
                    </div>
                    
                    <div className="col-lg-3 col-md-6 mt-4 pt-2">
                        <div className="card team team-primary text-center border-0">
                            <div className="position-relative">
                                <img src="assets/images/pages/team4.jpg" className="img-fluid rounded  shadow" alt="" />
                                <ul className="list-unstyled mb-0 team-icon">
                                    <li className="list-inline-item"><a href="#" className="btn btn-primary btn-pills btn-sm btn-icon"><i data-feather="facebook" className="icons"></i></a></li>
                                    <li className="list-inline-item"><a href="#" className="btn btn-primary btn-pills btn-sm btn-icon"><i data-feather="instagram" className="icons"></i></a></li>
                                    <li className="list-inline-item"><a href="#" className="btn btn-primary btn-pills btn-sm btn-icon"><i data-feather="twitter" className="icons"></i></a></li>
                                </ul>
                            </div>
                            <div className="card-body py-3 px-0 content">
                                <h6 className="mb-0"><a href="#" className="name text-dark"><span className='text-primary'>ӨЛЗИЙСАЙХАН</span> Ганболдын</a></h6>
                                <small className="designation text-muted">Сургалт, мэдлэгийн менежмент хариуцсан дэд захирал</small><br/>
                                <small className="designation text-bold">Доктор (Ph.D)</small>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    </>
  )
}

export default Member